import { NgModule } from '@angular/core';
import { AppendViewContainerRefDirective } from './append-view-container-ref-directive';

@NgModule({
  imports: [],
  exports: [AppendViewContainerRefDirective],
  declarations: [AppendViewContainerRefDirective],
})
export class MdlCommonsModule {}



// WEBPACK FOOTER //
// ./src/lib/components/common/index.ts